import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/newsAndGuides/details/pageContext';

export function NewsAndGuidesDetailsErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for NewsAndGuidesDetails page (error: ${error})`);
}
